import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  details: {
    textAlign: ({ contentAlign }) => contentAlign,
    paddingTop: ({ hasPadding }) => hasPadding && 28,
    paddingBottom: ({ hasPadding }) => hasPadding && 28,

    '& a': {
      textDecoration: 'none'
    }
  }
})

export default useStyles
